const projectionDefaults = () => ({
  bassica: { normal: 40000000, promotion: 50000000, sale: false },
  sahet: { normal: 180000000, promotion: 300000000, sale: false }
})

function restrictPaymentMethod (owner, method) {
  return owner.id === 'e47f83a62c10' && ['visa', 'mastercard', 'nequi'].includes(method)
}

function buildProjection (brand, owners, history, budget) {
  const historical = (history && history.brands.find(item => item.brand === brand.brand)) || { previous: [], current: [] }
  const sum = rows => rows.reduce((total, row) => total + row.value, 0)
  const previousTotal = sum(historical.previous)
  const currentTotal = sum(historical.current)
  const target = Number(budget[budget.sale ? 'promotion' : 'normal'])
  const validBudget = Number.isFinite(target) && target >= 0
  const remaining = validBudget ? Math.max(0, target - currentTotal) : null
  const methods = {}
  brand.methods.forEach(method => {
    const previous = sum(historical.previous.filter(row => row.method === method.method))
    const active = method.allocations.filter(allocation => allocation.enabled && owners.some(owner => owner.id === allocation.ownerId && owner.enabled))
    const validDistribution = active.every(allocation => Number.isFinite(allocation.percentage) && allocation.percentage >= 0 && allocation.percentage <= 100) &&
      Math.abs(active.reduce((total, allocation) => total + allocation.percentage, 0) - 100) < 0.000001
    methods[method.method] = { share: previousTotal ? previous / previousTotal : null, valid: validDistribution }
  })
  const displayOwners = owners.map(owner => ({ id: owner.id, name: owner.name || 'Nuevo propietario', enabled: owner.enabled, historicalOnly: false }))
  historical.current.forEach(row => {
    if (!displayOwners.some(owner => owner.id === row.ownerId)) displayOwners.push({ id: row.ownerId, name: row.ownerName, enabled: false, historicalOnly: true })
  })
  const rows = displayOwners.map(owner => {
    const cells = {}
    brand.methods.forEach(method => {
      const current = sum(historical.current.filter(row => row.ownerId === owner.id && row.method === method.method))
      const allocation = method.allocations.find(item => item.ownerId === owner.id)
      const weight = owner.enabled && allocation && allocation.enabled ? Number(allocation.percentage) / 100 : 0
      const info = methods[method.method]
      const expected = history && validBudget && info.share !== null && info.valid ? remaining * info.share * weight : null
      cells[method.method] = { current, expected, closing: expected === null ? null : current + expected }
    })
    const values = Object.keys(cells).map(method => cells[method])
    const current = values.reduce((total, value) => total + value.current, 0)
    const expected = values.every(value => value.expected !== null) ? values.reduce((total, value) => total + value.expected, 0) : null
    return { ...owner, cells, total: { current, expected, closing: expected === null ? null : current + expected } }
  })
  const totals = {}
  brand.methods.forEach(method => {
    const values = rows.map(row => row.cells[method.method])
    const current = values.reduce((total, value) => total + value.current, 0)
    const expected = values.every(value => value.expected !== null) ? values.reduce((total, value) => total + value.expected, 0) : null
    totals[method.method] = { current, expected, closing: expected === null ? null : current + expected }
  })
  const ready = !!history && previousTotal > 0 && validBudget && Object.keys(methods).every(method => methods[method].valid)
  return { previousTotal, currentTotal, target, remaining, validBudget, methods, rows, totals, ready, closing: ready ? currentTotal + remaining : null }
}

export { projectionDefaults, restrictPaymentMethod, buildProjection }



// WEBPACK FOOTER //
// ./src/components/pages/paymentConfig/paymentProjection.js